import type { PresentationBrandingMode } from '@/domain/presentation/contracts';

export interface PresentationBrandingProps {
  mode: PresentationBrandingMode;
  companyName?: string;
  logoUrl?: string;
}

/**
 * SPEC-011 §17-20/§75/§79/§80 — three branding modes. The Dark Funnels
 * wordmark is plain text (same approach as `AuthenticatedShell`'s header,
 * SPEC-002) rather than an external image URL (§79: no hardcoded external
 * asset dependency). Client logos use `object-fit: contain`, never crop
 * (§80/AC-076).
 */
export function PresentationBranding({ mode, companyName, logoUrl }: PresentationBrandingProps) {
  if (mode === 'minimal') {
    return <span className="text-xs text-text-muted">Dark Funnels</span>;
  }

  if (mode === 'client') {
    return (
      <div className="flex items-center gap-2">
        {logoUrl ? (
          <img
            src={logoUrl}
            alt={companyName ?? 'Logotipo da empresa'}
            className="h-7 max-w-[160px] object-contain"
          />
        ) : null}
        {companyName ? (
          <span className="text-sm font-medium text-text-primary">{companyName}</span>
        ) : null}
        <span className="text-[10px] text-text-muted">por Dark Funnels</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <span
        className="text-sm font-semibold tracking-tight"
        style={{ color: 'var(--df-text-brand)' }}
      >
        Dark Funnels
      </span>
    </div>
  );
}
